import { format } from "date-fns";

export function validateUrl(url) {
  const regex = new RegExp(
    /^(https|ftp):\/\/([A-Z0-9][A-Z0-9-]{0,61}[A-Z0-9]\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9-]{2,}\.?)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|(\[?[A-F0-9]*:[A-F0-9:]+\]?)\b(?::\d+)?(\/[A-Z0-9+&@#\/%=~_|$?!:,.]*)?$/i
  );

  if (!regex.test(url)) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);

    if (!["http:", "https:", "ftp:"].includes(parsedUrl.protocol)) {
      return false;
    }

    const excludedHosts = ["localhost", "127.0.0.1", "::1"];
    if (
      excludedHosts.includes(parsedUrl.hostname) ||
      parsedUrl.hostname.startsWith("192.168.") ||
      parsedUrl.hostname.startsWith("10.")
    ) {
      return false;
    }

    const tld = parsedUrl.hostname.split(".").pop();
    if (tld.length < 2) {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
}

export const convertTimestampToHumanReadable = (timestamp) => {
  const date = new Date(timestamp);
  return format(date, "yyyy-MM-dd HH:mm:ss") + " UTC";
};

export const disableLink = (record) => {
  return record.request_sttaus === "In-Progress" ? null : record.signed_url;
};

export const pdfGridColumns = {
  request_timestamp: "Timestamp",
  campaign: "Campaign",
  current_contacts: "Contacts",
  custom_template_name: "Template",
  request_status: "Status",
  conditional_url: "File",
};

export const campaignGridColumns = {
  campaign_name: "Campaign",
  total: "#Contacts",
};

export const respondedGridColumns = {
  greeting_name: "Full Name",
  "ma-addr_line1": "Street",
};

export const contactVisitsGridColumns = {
  visited: "visited",
  trackable: "qrcode-id",
  campaign: "campaign",
};

export const existingUsersGridColumns = {
  customer_id: "Customer ID",
  name: "Customer",
  email: "E-mail address",
  phone: "Contact number",
  tpx_id: "Tracking pixel",
  created: "Created",
  user_id: "Cognito user ID",
  cognito_pool_id: "Cognito pool ID",
  role: "Role",
};

export const generateGridColumns = (mappingConfig,alwaysVisibleColumn) => {
  return Object.keys(mappingConfig).map((key) => {
    const column = {
      field: key,
      headerName: mappingConfig[key],
      flex: 1,
      minWidth: 150,
      hideable: key!==alwaysVisibleColumn
    };

    if (key === "conditional_url") {
      column.renderCell = (params) => {
        return params.value ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#1976d2",
              fontWeight: 500,
            }}
          >
            Download
          </a>
        ) : (
          "None"
        );
      };
    }

    return column;
  });
};

export const pdfRequestRowMapping = {
  request_timestamp: "request_timestamp",
  campaign: "campaign",
  current_contacts: "current_contacts",
  custom_template_name: "custom_template_name",
  request_status: "request_status",
  conditional_url: "conditional_url",
};
export const campaignRowMapping = {
  campaign_name: "campaign_name",
  total: "total",
};
export const respondedRowMapping = {
  greeting_name: "greeting_name",
  "ma-addr_line1": "ma-addr_line1",
};
export const contactVisitsRowMapping = {
  visited: "visited",
  trackable: "trackable",
  campaign: "campaign",
};
export const existingUsersRowMapping = {
  customer_id: "customer_id",
  name: "name",
  email: "email",
  phone: "phone",
  tpx_id: "tpx_id",
  created: "created",
  user_id: "user_id",
  cognito_pool_id: "cognito_pool_id",
  role: "role",
};

export const generateGridRows = (data, mappingConfig, startIndex = 1) => {
  return data.map((record, index) => {
    const row = { id: startIndex + index };
    Object.keys(mappingConfig).forEach((key) => {
      const value = record[mappingConfig[key]];
      row[key] = Array.isArray(value) ? value.join(", ") : value;
    });
    return row;
  });
};
export const campaignMapping = {
  campaign_name: "Campaign",
  total: "Contacts",
  created: "Created",
  destination_url: "Destination",
};
export const respondedMapping = {
  created: "created",
  trackable_url: "trackable_url",
  trackable: "qrcode-id",
  envelope_name: "envelope_name",
  greeting_name: "greeting_name",
  "ma-addr_line1": "ma-addr_line1",
  "ma-city": "ma-city",
  "ma-state": "ma-state",
  "ma-zip": "ma-zip",
  visits: "visits",
};

export const contactVisitsMapping = {
  visited: "visited",
  trackable: "qrcode-id",
  country: "country",
  user_agent: "user-agent",
  city: "city",
  region: "region",
};

export const generateFormData = (selectedRow, mappingConfig) => {
  return Object.keys(mappingConfig).map((key) => ({
    label: mappingConfig[key],
    value: selectedRow[key],
  }));
};
